import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-bootstrap';
import classNames from 'classnames';

const ActionGrid = ({ className, id, children }) => (
	<div className={classNames('page-header-action-grid', className)} id={id}>
		<Grid className="flex-center">
			{ children }
		</Grid>
	</div>
);

ActionGrid.propTypes = {
	children  : PropTypes.any,
	className : PropTypes.string,
	id        : PropTypes.string,
};

ActionGrid.defaultProps = {
	children  : undefined,
	className : undefined,
	id        : undefined,
};

export default ActionGrid;

export { default as Action } from './action';
